import Spinner from "@patient-watch/ui/spinner";

const FormLoading = ({ className }: { className?: string }) => {
    return (
        <div className="flex justify-center items-center h-60">
            <Spinner className={className} />
        </div>
    );
};

export default FormLoading;
